import { Box, TextField, styled } from "@mui/material";

const StyledContainer = styled(Box)({
  display: "flex",
  flexDirection: "column",
  gap: "16px",
  width: "100%",
});

const StyledTextField = styled(TextField)(({ theme }) => ({
  height: "56px",
  backgroundColor: theme.palette.semanticSurface?.dark || "#333",
  borderTopLeftRadius: 6,
  borderTopRightRadius: 6,
  borderBottom: `2px ${theme.palette.semanticNeutral?.light || "#ccc"} solid`,
  "& label": {
    color: theme.palette.semanticNeutral?.light || "#ccc",
  },
  "& .MuiInputBase-root": {
    backgroundColor: "transparent",
    color: "#fff",
  },
  "& .Mui-disabled": {
    color: theme.palette.semanticNeutral?.light || "#ccc",
    "-webkit-text-fill-color": theme.palette.semanticNeutral?.light || "#ccc",
    opacity: 1,
  },
}));

const StaticMessageForm = () => (
  <StyledContainer>
    <StyledTextField label="Name" variant="filled" fullWidth placeholder="Name" disabled />
    <StyledTextField label="+1 ▾ Phone" variant="filled" fullWidth placeholder="Phone" disabled />
    <StyledTextField label="Email" variant="filled" fullWidth placeholder="Email" disabled />
    <StyledTextField label="Message" variant="filled" fullWidth placeholder="Message" disabled />
  </StyledContainer>
);

export default StaticMessageForm;
